import { Column } from "@/components/containers";
import { BackgroundImage } from "@/components/displays";
import { FEATURE_FLAG } from "@/configs/system";

import ImgBanner from "$/images/campaign/freeDeliveryfee/bnr_freedelivery_pc.jpg";
import ImgBannerSp from "$/images/campaign/freeDeliveryfee/bnr_freedelivery_sp.jpg";

import styles from "./FreeShippingSection.module.scss";

export function FreeShippingSection(): React.ReactNode {
  if (!FEATURE_FLAG.isFreeShippingCampaignActive) return null;

  return (
    <Column>
      {/* SPとPCで画像を出し分けできるので、本来の用途ではないが利用 */}
      <BackgroundImage bgImagePC={ImgBanner} bgImageSP={ImgBannerSp} className={styles.banner} />
      <section className="container">
        <div className="row">
          <div className="col-12 pd__top__m pd__bottom__m">
            <p className="text__s text__gray__dark">
              ※2025/6/4
              14時まで（システム反映により前後する場合あり）、公式オンラインショップのみ対象です。※継続コース初回の常温便送料500円が無料、冷凍便は対象外。2回目以降は送料がかかります。※継続コースを初めて購入する方、過去に購入したがすでに解約済の方（常温便・冷凍便ともに解約済）限定です。
            </p>
          </div>
        </div>
      </section>
    </Column>
  );
}
